export const STUDENT_ID_PREFIX = 'ULK-';

export const toRegistrationIdSuffix = (value) => {
    let raw = String(value || '').replace(/\s+/g, '');
    const upper = raw.toUpperCase();
    if (upper.startsWith('ULK-')) {
        raw = raw.slice(4);
    } else if (upper.startsWith('ULK')) {
        raw = raw.slice(3);
    }
    return raw.replace(/^-+/, '');
};

export const normalizeStudentRegistrationId = (value) => {
    const suffix = toRegistrationIdSuffix(value).toUpperCase();
    return suffix ? `${STUDENT_ID_PREFIX}${suffix}` : '';
};

export const validateStudentRegistrationId = (value) => {
    const id = normalizeStudentRegistrationId(value);
    if (!id || id.length <= STUDENT_ID_PREFIX.length) {
        return {
            valid: false,
            message: 'Registration ID is required. Enter characters after ULK-.'
        };
    }
    if (id.length > 50) {
        return {
            valid: false,
            message: 'Registration ID is too long (max 50 characters).'
        };
    }
    return { valid: true, value: id };
};
